module.exports = __webpack_public_path__ + "img/s3-title.977ec4db.png";